// extracted by mini-css-extract-plugin
export default {"header":"Header_header__hQ+nM","headerContainer":"Header_headerContainer__osn42","headerTitle":"Header_headerTitle__mfnyt","headerSubtitle":"Header_headerSubtitle__Ipk-K"};